import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { CmsConverterService, defaultFSCatalog } from '../../../../../services/cms-converter/cms-converter.service'
import { ConvertedComponentData, FsCatalog } from '../../../../types'

@Injectable({ providedIn: 'root' })
export class OpenPanelMainContentFullWidthRowConverter extends CmsConverterService<OpenPanelMainContentFullWidthRowData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      items: formData.st_items ?? defaultFSCatalog
    }
  }
}

export const OPEN_PANEL_MAIN_CONTENT_FULL_WIDTH_ROW_CONVERTER_TOKEN =
  new InjectionToken<Converter<CmsComponent, OpenPanelMainContentFullWidthRowData>>('OpenPanelMainContentFullWidthRowConverter')

export interface OpenPanelMainContentFullWidthRowData extends ConvertedComponentData {
  items: FsCatalog;
}
